import React, {useEffect} from "react";
import {Image, View, useTheme, Text, Heading, Flex, useAuthenticator, Button} from "@aws-amplify/ui-react";
import {Link} from 'react-router-dom';
import {useLocation, useNavigate} from "react-router";
import coachingLogoWhite from '../../assets/images/logo/logo-white.svg';
import styles from "./index.module.css";
import Footer from "../../components/NoAuth/Footer";

export default function ThankYou() {
  const {route} = useAuthenticator((context) => [context.route]);
  const location = useLocation();
  const navigate = useNavigate();
  let from = location.state?.from?.pathname || '/';

  useEffect(() => {
    if (route === 'authenticated') {
      navigate(from, {replace: true});
    }
  }, [route, navigate, from]);

  const mainFlexClassNames = ["auth-wrapper", styles.mainFlex];
  const {tokens} = useTheme();

  return (
    <Flex
      direction="row"
      justifyContent="center"
      className={mainFlexClassNames.join(" ")}
    >
      <View
        className={styles.contentView}
      >
        {/*header logo*/}
        <View textAlign="center" padding={tokens.space.large}>
          <Image
            alt="Myedu logo"
            src={coachingLogoWhite}
          />
        </View>

        {/*main section*/}
        <View className={styles.registerWrapper}>
          <Heading
            padding={`0 0 ${tokens.space.xl} 0`}
            level={3}
          >
            Registrazione completata
          </Heading>

          <Text
            className={styles.loginText}
          >
            Vai alla pagina di login per proseguire
          </Text>
          <Link
            className={styles.loginLink}
            to="/login"
          >
            <Button
              isFullWidth
              className={styles.loginBtn}
              variation="primary"
            >
              Vai al Login
            </Button>
          </Link>
        </View>

        {/*footer text*/}
        <Footer />
      </View>
    </Flex>
  )
}
